var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tool-intro-/-icon_time"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_time"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    x: 0,
    y: 0,
    width: "26px",
    height: "26px"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Time",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9042105,25.8107018 C5.77741184,25.8107018 8.72781119e-16,20.0332899 0,12.9064912 C-8.72781119e-16,5.77969255 5.77741184,0.00228070175 12.9042105,0.00228070175 C20.0310092,0.00228070175 25.8084211,5.77969255 25.8084211,12.9064912 C25.7996247,20.0296432 20.0273625,25.8019054 12.9042105,25.8107018 Z M12.9042105,1.59649123 C6.6591296,1.59649123 1.59649123,6.6591296 1.59649123,12.9042105 C1.59649123,19.1492915 6.6591296,24.2119298 12.9042105,24.2119298 C19.1492915,24.2119298 24.2119298,19.1492915 24.2119298,12.9042105 C24.2043897,6.66225549 19.1461656,1.60403135 12.9042105,1.59649123 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9042105,13.7024561 C12.4633516,13.7024561 12.1059649,13.3450694 12.1059649,12.9042105 L12.1059649,9.52877193 C12.1059649,9.08791305 12.4633516,8.73052632 12.9042105,8.73052632 C13.3450694,8.73052632 13.7024561,9.08791305 13.7024561,9.52877193 L13.7024561,12.9042105 C13.7024561,13.3450694 13.3450694,13.7024561 12.9042105,13.7024561 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1257895,17.9240351 C16.9152372,17.9255137 16.7126768,17.8435055 16.5624561,17.6959649 L12.3431579,13.4766667 C12.1394538,13.2749996 12.0588116,12.9799768 12.1316083,12.7027304 C12.2044051,12.425484 12.4195812,12.2081343 12.696082,12.132555 C12.9725828,12.0569756 13.2684012,12.1346488 13.4721053,12.3363158 L17.6914035,16.555614 C17.9236961,16.7832021 17.994703,17.1289559 17.8709077,17.4296732 C17.7471124,17.7303906 17.4532663,17.9259465 17.1280702,17.9240351 L17.1257895,17.9240351 Z",
    id: "Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTime);
export default __webpack_public_path__ + "static/media/icon_time.d1f21e50b84e3766a36f42a34656b989.svg";
export { ForwardRef as ReactComponent };